export default 
[
  {
    id: 1, 
    nome: 'Português',
    simbolo: 'pt-Br',
    imagem: 'img/acesso/atalhos/pt-BR.png'
  },
  {
    id: 2,
    nome: 'Inglês',
    simbolo: 'en',
    imagem: 'img/acesso/atalhos/en.png'
  },
  {
    id: 3,
    nome: 'Espanhol',
    simbolo: 'es',
    imagem: 'img/acesso/atalhos/es.png'
  },
  {
    id: 4,
    nome: 'Francês',
    simbolo: 'fr',
    imagem: 'img/acesso/atalhos/fr.png'
  },
  {
    id: 5,
    nome: 'Italiano',
    simbolo: 'it',
    imagem: 'img/acesso/atalhos/it.png'
  },
]



// WEBPACK FOOTER //
// ./FrontEnd/js/linguagens.js